import { useDispatch, useSelector } from "react-redux";
import { serviceActions } from "../../store/service-Slice";
import { getGroups, getSinglePadlock, getSinglePadlockEvents, updateLockDetails } from "../../Api Methods/Api";
import { Await, defer, useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from './padlockEntity.module.css'
import { format } from "date-fns";
import { Suspense, useEffect, useRef, useState } from "react";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import LogsTableLayout from "../../components/Table/LogsTableLayout";
import PadlockEvents from "./PadlockEvents";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import DataManager from "../../hooks/DataManager";


const PadlockEntity = () => {

    const { padlock } = useLoaderData();

    // const [padlock, setPadlock] = useState()

    const [localPadlock, setLocalPadlock] = useState(padlock)
    const companyName = useSelector(state => state.auth.companyName);
    const role = useSelector(state => state.auth.role);
    const isAllowed = companyName == "EyeSpyFX" || companyName == "KNOWIO" ? true : false
    const isCustomerBillingAllowed = companyName === "EyeSpyFX"
    
    const [unauthotisedClick, setUnauthorisedClick] = useState(false)

    const dataManager = new DataManager();
    const [lockEvents, setLockEvents] = useState([])
    const [showLoading, setShowLoading] = useState(true)
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([])
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');
    const apiData = {
        token, 
        client
    }
    const [changeLockName, setChangeLockName] = useState(false)
    const [changeOwnedBy, setChangeOwnedBy] = useState(false)
    const [changeBillable, setChangeBillable] = useState(false)
    const [changeBilledTo, setChangeBilledTo] = useState(false)
    const [lockName, setNewLockName] = useState(localPadlock.lockName)
    const [PINVisible, setPINVisible] = useState(false)
    const [masterPIN, setMasterPIN] = useState("********")

    const [newOwnerGroupName, setNewOwnerGroupName] = useState(localPadlock.ownedByGroupName || localPadlock.owner)
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(localPadlock.billedToGroupName || localPadlock.owner)
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false)
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(localPadlock.customerBilledToGroupName || "")

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false)
    const [navigateToGroup, setNavigateToGroup] = useState(false)
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false)
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false)
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false)
    const [newBillingFrequency, setNewBillingFrequency] = useState("")
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("")
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("")

    const billingOptions = ["Monthly", "Annually"]

    const [userObject, setUserObject] = useState([])

    const toast = useRef(null);
    const navigate = useNavigate();

    //Stat values converted
    
    const ownedBy = localPadlock.ownedByGroupName !== null ? localPadlock.ownedByGroupName || localPadlock.usedBy : "Unlinked"
    
    const GetGroups = async () => {
        const groups = await getGroups(apiData, dispatch)
        setGroups(groups)
    }

    const GetLockEvents = async () => {
        const response = await getSinglePadlockEvents(apiData, padlock.lockID)
        if (response.success){
            setLockEvents(response.data)
            setShowLoading(false)
        }
    }

    useEffect(() => {
        GetLockEvents();
        GetGroups();
    }, [])

    useEffect(() => {
        setMasterPIN(PINVisible ? localPadlock.masterPin : "********")
    }, [PINVisible])

    useEffect(() => {
        if (navigateToLinkedSite){
            navigate(`/Dashboard/SiteView/${localPadlock.deviceUUID}`)
        }
    }, [navigateToLinkedSite])

    useEffect(() => {
        if (navigateToGroup){
            const groupClicked = groups.find(g => g.name === localPadlock.usedBy);
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate(`/Dashboard/Groups/GroupSites/`)
        }
    }, [navigateToGroup])

    const UpdateLockDetails = async (columnName, newValue) => {
        let body = {
            lockID: padlock.lockID,
            columnName: columnName,
            newValue: newValue
        }
        const response = await updateLockDetails(apiData, body, dispatch)
        if (response.success){
            setLocalPadlock((prevPadlockObj) => ({
                ...prevPadlockObj,
                [columnName]: body.newValue,
            }));
        }
    }

    useEffect(() => {
        if (unauthotisedClick){
            toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update billing for this Padlock', life: 3000 });
            setUnauthorisedClick(false)
        }
    }, [unauthotisedClick])

    const accept = async () => {
        UpdateLockDetails("billable", localPadlock.billable == 1 ? 0 : 1)    
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing status updated', life: 3000 });
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Cancelled', detail: 'Changes discarded', life: 3000 });
    }

    const defaultConfirmProps = {
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        defaultFocus: 'accept',
        accept,
        reject,
    };

    const updateLockName = async () => {
        UpdateLockDetails("lockName", lockName)

        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Internal serial updated', life: 3000 });
        setChangeLockName(false)
    }   

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName).id;
        UpdateLockDetails("ownedByGID", newOwnerID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Lock owner updated', life: 3000 });
        setChangeOwnedBy(false)

        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            ownedByGroupName: newOwnerGroupName,
        }));
    }

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName).id;
        UpdateLockDetails("billedToGID", newBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Lock subscription updated', life: 3000 });
        setChangeBilledTo(false)

        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            billedToGroupName: newBilledToGroupName,
        }));
    }

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;
        UpdateLockDetails("customerBilledToGID", newCustomerBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Customer billed to updated', life: 3000 });
        setChangeCustomerBilledTo(false)
        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            customerBilledToGroupName: newCustomerBilledToGroupName,
            customerBilledToGID: newCustomerBilledToID,
        }));
    }

    const updateBillingFrequency = async () => {
        UpdateLockDetails("billingFrequency", newBillingFrequency.toLowerCase())
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing frequency updated', life: 3000 });
        setChangeBillingFrequency(false)

        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            billingFrequency: newBillingFrequency,
        }));
    }

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : ""
        UpdateLockDetails("firstInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfFirstInvoice(false)

        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            firstInvoiceDate: formattedDate,
        }));
    }

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : ""
        UpdateLockDetails("lastInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfLastInvoice(false)

        setLocalPadlock((prevPadlockObj) => ({
            ...prevPadlockObj,
            lastInvoiceDate: formattedDate,
        }));
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Set internal serial"
                visible={changeLockName}
                style={{ width: '50vw' }}
                onHide={() => { if (!changeLockName) return; setChangeLockName(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <InputText
                        value={lockName}
                        onChange={(e) => setNewLockName(e.target.value)}
                        style={{ width: '100%', fontSize: '1rem' }}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeLockName(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateLockName}/>
                    </div>
                </div>
            </Dialog>

            <ConfirmDialog
                    visible={changeBillable}
                    onHide={() => setChangeBillable(false)}
                    {...defaultConfirmProps}
                    message={`Are you sure you want to ${localPadlock.billable == 0 ? 'start' : 'stop'} billing for this padlock?`}
            />

            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: '50vw', height:'20vw' }}
                onHide={() => { if (!changeOwnedBy) return; setChangeOwnedBy(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newOwnerGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewOwnerGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeOwnedBy(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateOwnedBy}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: '50vw', height:'20vw' }}
                onHide={() => { if (!changeBilledTo) return; setChangeBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newBilledToGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateBilledTo}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: '50vw', height: '20vw' }}
                onHide={() => { if (!changeCustomerBilledTo) return; setChangeCustomerBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewCustomerBilledToGroupName(e.value)}
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: '30vw', height:'20vw' }}
                onHide={() => { if (!changeBillingFrequency) return; setChangeBillingFrequency(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={(e) => setNewBillingFrequency(e.value)}/>
                </div>
                <br/>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary"/>
                    <Button icon="pi pi-save" label="Save" onClick={updateBillingFrequency}/>
                </div>
            </Dialog>

            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfFirstInvoice) return; setChangeDateOfFirstInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary"/>
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice}/>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfLastInvoice) return; setChangeDateOfLastInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={(e) => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd mm yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary"/>
                        <Button icon="pi pi-save" label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice}/>
                    </div>
                </div>
            </Dialog>

            <div className={classes['activtyPage_container']}>
                <Await resolve={localPadlock}>
                    {(loadedPadlock) => (
                        <div className={classes.container}>                        
                            <Stats2 title={"Lock ID"} value={loadedPadlock.lockID} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Internal serial"} value={loadedPadlock.lockName || "Not set"} isLoadingStats={false} isStatic={true} setChangeLockName={setChangeLockName} editable={role === "admin" || role === "TechSupport"} />
                            {(role === "admin" || role === "TechSupport") && <Stats2 title={"Master PIN"} value={masterPIN} isLoadingStats={false} isStatic={true} setPINVisible={setPINVisible}/>}

                            {localPadlock.usedBy && <Stats2 title={"Linked to"} value={localPadlock.tag || localPadlock.linkedSite} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} /> }
                            {localPadlock.usedBy && <Stats2 title={"Output"} value={loadedPadlock.pinName || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite}/> }
                            
                            <Stats2 title={"Timezone"} value={loadedPadlock.tzid} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Registration date"} value={format(new Date(loadedPadlock.registerDate), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Registered by"} value={loadedPadlock.registeredByName} isLoadingStats={false} isStatic={true} />
                            
                            <Stats2 title={"Last updated"} value={format(new Date(loadedPadlock.batteryReadAt), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Battery"} value={loadedPadlock.battery !== 0 ? `${loadedPadlock.battery}%` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            
                            {localPadlock.usedBy && <Stats2 title={"Used by"} value={loadedPadlock.usedBy || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup}/>}
                            <Stats2 title={"Owned by"} value={ownedBy} isLoadingStats={false} isStatic={true} setChangeOwnedBy={setChangeOwnedBy} editable={isAllowed} />
                            {isAllowed && <Stats2 title={"Billable"} value={loadedPadlock.billable == 1 ? "Yes" : "No"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} editable={isAllowed} />}
                            {(loadedPadlock.billable == 1)&& <Stats2 title={"Billed to"} value={loadedPadlock.billedToGroupName || "Not set"} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeBilledTo} isAllowedToChange={isAllowed} editable={isAllowed} />}
                            {/* <Stats2 title={"Customer billed to"} value={localPadlock.customerBilledToGroupName || "Not set"} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeCustomerBilledTo} isAllowedToChange={isCustomerBillingAllowed} editable={isCustomerBillingAllowed} /> */}

                            {/* Inniovate only */}
                            {isAllowed && <Stats2 title={"Billing frequency"} value={loadedPadlock.billingFrequency != null ? loadedPadlock.billingFrequency : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeBillingFrequency={setChangeBillingFrequency} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of hardware invoice"} value={loadedPadlock.firstInvoiceDate != null ? format(new Date(loadedPadlock.firstInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of 1st SaaS invoice"} value={loadedPadlock.lastInvoiceDate != null ? format(new Date(loadedPadlock.lastInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} setChangeDateOfLastInvoice={setChangeDateOfLastInvoice} editable={isAllowed} />}

                        </div>
                    )}
                </Await>
                    <p>Previous events (Max 100)</p>
                <Await resolve={lockEvents}>
                    {(loadedLockEvents) => {
                        return (
                            <>
                                <div style={{ display: "flex", width: "100%" }}>
                                    {showLoading ? (
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <DeviceLoadingGrid
                                                CardCount={20} />
                                        </div>
                                    ) : (
                                        <PadlockEvents events={loadedLockEvents} />
                                    )}
                                </div>
                            </>
                        )
                    }}
                </Await>
            </div>
        </>
    )
}

export default PadlockEntity;

export async function padlockLoader({ params }) {
    const lockID = params.LockID;
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');

    return { 
        padlock: await getSinglePadlock({ token, client }, lockID) };
}
